import { Injectable } from '@angular/core';
import { JwtHelperService } from '@auth0/angular-jwt';
import { RestService } from '../rest/rest.service';
import { LoginResponse, GenericResponse } from 'src/app/interfaces/apiresponses';
import { of } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class AuthService {
  isLogin = false
  userRole: string = ''
  isTempPassword = false

  constructor(
    public jwtHelper: JwtHelperService,
    private service: RestService,) { }

  isLoggedIn() {
    const token = localStorage.getItem('token');
    const isTemporaryPassword = localStorage.getItem('temppassword') === 'true'?true:false

    if (token === undefined || token === '')
      return false;

    if (isTemporaryPassword)
      return false;
    
    if (this.jwtHelper.isTokenExpired(token))
      return false;
    else
      return true;
  }

  getRole() {
    this.userRole = localStorage.getItem('userType') || ''
    return this.userRole
  }

  getUserEmail() {
    this.userRole = localStorage.getItem('email') || ''
    return this.userRole
  }
}
